export default function (context) {
  context.store.dispatch('me/getUserInfo')
}
